import(/* webpackMode: "eager" */ "/Users/ginkgo/Desktop/comverse /comverse-baseapp-next/app/payment/page.jsx");
